const apiUrls = {
  /*
  * Auth
  */
  LOGIN: "portals/customer/login",
  FORGOT_PASSWORD: "portals/customer/recoverPassword",
  RESET_PASSWORD: "portals/customer/resetPassword",
  REGISTER: "portals/customer/register",
  VERIFY_OTP: "portals/customer/verifyOtp",
  REQUEST_OTP: "portals/customer/sendOtp",
  CHECK_DUPLICATE: "portals/customer/checkDuplicate",
  CHECK_DUPLICATE_CUSTOMER_PHONE: "portals/customer/customer",
  SEARCH_CUSTOMER: "core/customer/searchByMobilePhone",
  UPDATE_EMAIL_CUSTOMER: "core/customer/updateEmail",

  /*
  * Load when refresh
  */
  INIT: "portals/customer/setting",

  /*
  * Branch
  */
  BRANCHES: "portals/customer/setting/branch",
  BRANCH_BOOKING_DATE_RANGE: "portals/customer/bookingDateRange",

  /*
  * Acount
  */
  WEB_CUSTOMER: "portals/customer/webCustomer",
  CUSTOMER: "portals/customer/customer",
  SALON: "/portals/customer/mySalons",

  /*
  * Sale Ticket (used Booking and eStore, pass different parameter)
  */
  SALE_TICKET: "sale/saleTicket",
  SALE_TICKET_ESTIMATE: "sale/saleTicket/estimate",
  BOOKING_LIST: "sale/saleTicket/booking",
  APPOINTMENT_HISTORY: "sale/saleTicket/appointmentHistory",
  PURCHASE_HISTORY: "sale/saleTicket/purchaseHistory",

  /*
  * Service & Booking & Redemption
  */
  // booking
  PAYMENT_METHOD: "portals/customer/bookingPaymentMethods",
  EMPLOYEE_TIMESLOT: "portals/customer/employeeTimeslots",
  CANCEL_BOOKING: "portals/customer/cancelBookings",
  REDEMPTION: "sale/prepaidPurchase",
  SERVICES: "portals/customer/services",
  POPULAR_SERVICES: "portals/customer/topServices",
  PROMOTION_SERVICES: "portals/customer/promotionServices",

  /*
  * eStore
  */
 ESTORE_PAYMENT_METHOD: "portals/customer/eStorePaymentMethods",
 SERVICE_SALES: "portals/customer/serviceSales",
 POPULAR_SERVICE_SALES: "portals/customer/servicePopularSales",
 RETAIL_PRODUCTS: "portals/customer/retailProductSales",
 POPULAR_RETAIL_PRODUCTS: "portals/customer/retailProductPopularSales",
 COUPONS: "portals/customer/couponSales",
 POPULAR_COUPONS: "portals/customer/couponPopularSales",
 CARTS: "portals/customer/carts",
 CART: "portals/customer/cart",

  /*
  * Fiserv
  */
  FISERV_SUCCESS: "vendors/fiserv/responseSuccess",
  FISERV_FAIL: "vendors/fiserv/responseFail",

  /*
  / Stripe
  */
  STRIPE_SETUP_INTENT: "vendors/stripe/setupIntent",
  PAYMENT_INTENT: "vendors/stripe/paymentIntent",
  STRIPE_FAIL: "vendors/stripe/responseFail",
  STRIPE_SUCCESS: "vendors/stripe/responseSuccess",
  GET_CUSTOMER_SAVED_CARDS: "vendors/stripe/customerPaymentMethods",
};

export default apiUrls;
